import { ItemNotification } from 'actions/actionTypes';

export const loadItemNotificationRequest = () => ({ type: ItemNotification.LOAD_ITEM_NOTIFICATION_REQUEST });
export const loadItemNotificationSuccess = (responseData) => ({ type: ItemNotification.LOAD_ITEM_NOTIFICATION_SUCCESS, payload: responseData });
export const loadItemNotificationFailure = (errorMessage) => ({ type: ItemNotification.LOAD_ITEM_NOTIFICATION_FAILURE, payload: errorMessage });
